import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbCardModule,
  NbIconModule,
  NbButtonModule,
  NbTooltipModule,
  NbInputModule,
  NbAccordionModule,
  NbFormFieldModule,
  NbSelectModule,
  NbSpinnerModule,
} from '@nebular/theme';
import { ComponentsModule } from '../components.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateVcsAppV3Component } from './create-vcs-app-integration-v3.component';

@NgModule({
  declarations: [CreateVcsAppV3Component],
  imports: [
    CommonModule,
    RouterModule, // RouterModule.forRoot(routes, { useHash: true }), if this is your app.module
    NbCardModule,
    NbIconModule,
    NbButtonModule,
    NbTooltipModule,
    NbAccordionModule,
    NbFormFieldModule,
    NbInputModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    NbSpinnerModule,
    NbSelectModule,
  ],
  exports: [CreateVcsAppV3Component],
})
export class CreateVcsAppV3Module {}
